import React, { useContext, useState } from "react";
import { useQuery } from "@apollo/react-hooks";
import { Loading, Modal, MobileContext } from "components/common";
import { Box } from "@material-ui/core";
import { GET_NON_MATCHED_TRANSACTIONS_GQL } from "../../mutations";
import BoostSelfAddBills from "./BoostSelfAddBills";
import BoostSelfAddNoBills from "./BoostSelfAddNoBills";
import BoostDontSeePayment from "./BoostDontSeePayment";
import BoostSelectedBill from "./BoostSelectedBill";

const BoostSelfAdd = ({ isOpen, close, currentProductTier, lookbackPeriod }) => {
  const [selectedBill, setSelectedBill] = useState(null);
  const [showDontSeePayment, setShowDontSeePayment] = useState(false);
  const { data: { getNonMatchedTransactions = {} } = {}, loading } = useQuery(GET_NON_MATCHED_TRANSACTIONS_GQL);
  const { isMobile } = useContext(MobileContext);
  let { transactions } = getNonMatchedTransactions || [];

  if (loading) {
    return (<Loading boost />);
  }

  transactions = transactions.sort((a, b) => {
    return b.posteddate - a.posteddate;
  });

  const handleSelectedBill = (trans) => {
    const value = selectedBill ? null : trans;
    setSelectedBill(value);
  };

  const handleDontSeePayment = () => {
    setShowDontSeePayment(!showDontSeePayment);
  };

  const dynamicMaxHeight = isMobile ? "100vh" : "80vh";
  const dynamicMinHeight = isMobile ? "100vh" : "50vh";
  const dynamicMinWidth = isMobile ? "400px" : "450px";
  const dynamicItemsMaxHeight = isMobile ? "85vh" : "65vh";

  const RenderBillsSection = () => {

    if (showDontSeePayment || selectedBill) {
      return (<></>);
    }

    if (transactions.length) {
      return (
        <BoostSelfAddBills
          handleDontSeePayment={handleDontSeePayment}
          handleSelectedBill={handleSelectedBill}
          selectedBill={selectedBill}
          dynamicItemsMaxHeight={dynamicItemsMaxHeight}
          transactions={transactions}
        />
      );
    } 

    return (<BoostSelfAddNoBills close={close}/>);
  };

  return (
    <Modal
      isOpen={isOpen}
      close={close}
    >
      <Box>
        <div
          style={{ maxHeight: dynamicMaxHeight, minHeight: dynamicMinHeight, minWidth: dynamicMinWidth }}
          className="bg-gray-100 max-w-md mx-auto whitespace-normal rounded">
          {
            showDontSeePayment && (
              <BoostDontSeePayment
                lookbackPeriod={lookbackPeriod}
                handleDontSeePayment={handleDontSeePayment}
                currentProductTier={currentProductTier}
                close={close}
              />
            )
          }
          {
            selectedBill && (
              <BoostSelectedBill
                selectedBill={selectedBill}
                handleSelectedBill={handleSelectedBill}
                transactions={transactions}
              />
            )
          }
          {
            RenderBillsSection()
          }
        </div>
      </Box>
    </Modal>
  );
};

export default BoostSelfAdd;